<script>
  import GroupAjax from '@ajax/group';
  import ShareModal from '@app-components/modal/ShareModal.svelte';
  import ListCommentsDesktop from '@app-components/comments/ListCommentsDesktop.svelte';
  import ListSearchModal from '@app-components/modal/ListSearchModal.svelte';
  import BookmarkButton from '@app-components/BookmarkButton.svelte';
  import ListCopier from '@app-components/group/ListCopier.svelte';
  import ShareIcon from '@app-components/group/ShareIcon.svelte';
  import CreateAccountModal from '@app-components/modal/CreateAccountModal.svelte';
  import FloatingLikeOrComment from '@app-components/group/FloatingLikeOrComment.svelte';
  import ScoreBadge from '@components/ScoreBadge.svelte';

  import queryString from 'query-string';
  import { getCurrentUserStore } from '@stores/current_user';
  import { onMount } from 'svelte';
  import { goto } from '$app/navigation';

  export let groupStore;
  export let group;
  export let loaded;
  export let recs;
  export let mobile;
  export let mobileForCreate = false;
  export let commentId = null;
  export let showCommentsModal = commentId != null;
  export let displayStyle;
  export let showFloatingLikeOrComment = false;
  export let score = null;

  let currentUser = getCurrentUserStore('default');

  const minimumRecCount = 5;
  let likesCount = 0;
  let likedByUser = false;
  let showCreateAccountModal = false;
  let likeInProgress = false;

  $: commentsCount = (group && group.comments && group.comments.total) || 0;
  $: likesCount = (group && group.likes && group.likes.total) || 0;
  $: likedByUser = (group && group.likes && group.likes.current_user_liked) || false;
  $: owner = group && group.users.filter((u) => u.role == 'admin')[0];

  let queryParams;
  let showShareModal;
  let showSearchModal = false;

  let toggleBookmark;
  let bookmark;

  let toggleLike = async function () {
    if (!currentUser || !currentUser.id) {
      showCreateAccountModal = true;
      return;
    }

    if (likeInProgress) {
      return;
    }

    likeInProgress = true;

    if (likedByUser) {
      likesCount = likesCount - 1;
    } else {
      likesCount = likesCount + 1;
    }

    likedByUser = !likedByUser;
    await GroupAjax.like(group, {});

    if (groupStore) {
      groupStore.set(await GroupAjax.get(group.id));
    }

    likeInProgress = false;
  };

  onMount(() => {
    queryParams = queryString.parse(location.search) || {};
    commentId = queryParams['comment_id'] || queryParams['commentId'];
    showCommentsModal = queryParams['open-comments'] == 'true' || (!queryParams['detail_id'] && commentId != null);
    showShareModal = queryParams['open-share-with-members'] == 'true';

    if (queryParams && queryParams['open-comments'] == 'true') {
      window.history.replaceState(null, null, location.href.replace('?open-comments=true', ''));
    }
  });
</script>

<style style="text/scss" lang="scss" global>
  /* NOTE: this component uses global styles so that child components can access them too,
     but it is scoped using classes ("group-page-container-desktop") so the styles don't
     leak across the app. */

  .group-actions-container.mobile {
    position: fixed;
    z-index: 22;
    bottom: 64px;
    height: 64px;
    left: 0px;
    width: 100%;
    border-bottom: 1px solid var(--neutral-input-gray, #ececec);
    background: #fff;
    box-shadow: 0px -18px 28px 0px rgba(0, 0, 0, 0.04);
    padding: 16px;
    justify-content: space-between;
    gap: 8px;
    &.logged-out {
      bottom: 0px;
    }
    .action-group {
      gap: 8px;
    }
  }
  .group-actions-container.desktop {
    .regular-btn {
      &:hover {
        background: #ececec;
      }
    }
  }
  .group-actions-container {
    padding-left: 67px;
    flex-shrink: 0;
    display: flex;
    flex-direction: row;
    align-items: center;
    height: 32px;
    gap: 12px;
    position: relative;

    .action-group {
      flex-shrink: 0;
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 12px;
    }

    .clap-btn {
      .emoji {
        width: 21px;
        height: 21px;
        flex-shrink: 0;
        margin-top: -2px;
        display: inline-block;
        background: url(/images/icon__clapping.png) 50% no-repeat;
        background-size: cover;
        transition: all 0.2s ease-in-out;
      }

      :global(.emoji-active) {
        opacity: 0.2;
      }

      .claps-counter {
        margin-left: 12px;
        font-size: 14px;
        font-weight: 500;
      }
    }
    .regular-btn {
      transition: 0.1s all;
      margin-left: 0px;
      border-radius: 8px;
      line-height: 10px;
      font-size: 14px;
      font-weight: 500;
      background: white;
      color: black;
      border: none;
      outline: none;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 8px;
      margin-bottom: 0px;
      svg {
        width: 16px;
        height: 16px;
      }
    }

    .comments-btn {
      .comments-counter {
        margin-left: 8px;
        font-size: 14px;
        font-weight: 500;
      }
    }

    &.tile {
      padding-left: 0px;

      .action-group {
        gap: 6px;
      }

      .action-group-second {
        margin-left: auto;
      }
    }
  }
</style>

{#if showCreateAccountModal}
  <CreateAccountModal
    eventDetails={{ trigger_event: 'like_button', group_base_id: group?.id }}
    msgStyle="font-size: 20px;"
    mobile={mobileForCreate || mobile}
    successCallback={() => {
      showCreateAccountModal = false;
      toggleLike();
    }}
    beforeDataSend={(data) => {
      data['sign_up_source'] = {
        source: 'list-like',
        group_base_id: group && group.id,
      };

      return data;
    }}
    showPassword={true}
    saveButtonFlow={true}
    buttonText="Create account"
    bind:showModal={showCreateAccountModal} />
{/if}

{#if showCommentsModal && !mobile}
  <ListCommentsDesktop customGroupStore={groupStore} bind:showModal={showCommentsModal} bind:commentId={commentId} />
{/if}

{#if showShareModal}
  <ShareModal bind:showShareModal={showShareModal} group={group} mobile={mobile} />
{/if}
{#if showSearchModal}
  <ListSearchModal group={group} bind:showModal={showSearchModal} mobile={mobile} />
{/if}

<div
  class:modal-mode={showCommentsModal}
  class="group-actions-container {displayStyle} {mobile ? 'mobile' : 'desktop'} {currentUser && currentUser.id
    ? 'logged-in'
    : 'logged-out'}">
  <div class="action-group">
    {#if group.show_likes}
      <button class="comments-btn regular-btn" on:click|preventDefault|stopPropagation={toggleLike}>
        {#if likedByUser}
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path
              d="M11.84 2C11.0163 2.00179 10.2116 2.2535 9.52801 2.72324C8.84439 3.19299 8.31259 3.85961 8 4.63863C7.68707 3.85875 7.15444 3.19154 6.46978 2.72173C5.78511 2.25192 4.97929 2.00071 4.15467 2C1.86133 2 0 4.33879 0 6.68847C0 11.824 6.93333 16 8 16C9.06667 16 16 11.824 16 6.68847C16 4.33879 14.1387 2 11.84 2Z"
              fill="#FF5567" />
          </svg>
        {:else}
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="18" viewBox="0 0 20 18" fill="none">
            <path
              d="M14.08 2C13.2048 2.0019 12.3499 2.26934 11.6235 2.76845C10.8972 3.26755 10.3321 3.97584 10 4.80354C9.66751 3.97492 9.10159 3.26601 8.37414 2.76684C7.64668 2.26766 6.7905 2.00075 5.91433 2C3.47767 2 1.5 4.48496 1.5 6.9815C1.5 12.438 8.86667 16.875 10 16.875C11.1333 16.875 18.5 12.438 18.5 6.9815C18.5 4.48496 16.5223 2 14.08 2Z"
              stroke="black"
              stroke-width="1.5" />
          </svg>{/if}
        {#if likesCount > 0}
          <span class="comments-counter">{likesCount}</span>
        {/if}
      </button>
    {/if}

    {#if group.show_comments}
      <button
        class="comments-btn regular-btn"
        on:click|preventDefault|stopPropagation={() => {
          if (displayStyle == 'tile') {
            goto(`${group.path}?open-comments=true`);
          } else {
            showCommentsModal = !showCommentsModal;
          }
        }}>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18" fill="none">
          <path
            d="M9 1C4.584 1 1 4.20129 1 8.20291C1.01196 9.165 1.22668 10.1137 1.63012 10.9872C2.03357 11.8606 2.61667 12.639 3.34133 13.2716L3.13333 16.5583C3.12961 16.6358 3.14736 16.7129 3.18462 16.7809C3.22188 16.849 3.27721 16.9055 3.3445 16.9441C3.41179 16.9827 3.48843 17.002 3.56598 16.9998C3.64353 16.9977 3.71898 16.9741 3.784 16.9318L6.584 15.0644C7.36961 15.2897 8.18273 15.4047 9 15.4058C13.416 15.4058 17 12.2045 17 8.20291C17 4.20129 13.416 1 9 1Z"
            stroke="#1A1A1A"
            stroke-width="1.5" />
        </svg>
        {#if commentsCount > 0}
          <span class="comments-counter">{commentsCount}</span>
        {/if}
      </button>
    {/if}
  </div>
  <div class="action-group action-group-second">
    {#if displayStyle != 'tile'}
      {#if group.permissions && group.permissions.edit}
        <button
          class="share-btn regular-btn"
          on:click={() => {
            showShareModal = true;
          }}>
          <ShareIcon />
        </button>
      {:else}
        <ListCopier group={group} mobile={mobile} relatedUserId={owner?.id}>
          <button class="share-btn regular-btn">
            <ShareIcon />
          </button>
        </ListCopier>
      {/if}
    {/if}
    {#if score}
      <ScoreBadge score={score} />
    {/if}
    <button class="bookmark-button regular-btn" on:click|preventDefault|stopPropagation={toggleBookmark}>
      <BookmarkButton
        bind:bookmark={bookmark}
        bind:toggleBookmark={toggleBookmark}
        group={group}
        viewStyle="group"
        mobile={mobile}
        mobileForCreate={mobileForCreate} />
    </button>

    {#if !mobile && loaded && recs.length > minimumRecCount}
      <button
        class="search-btn regular-btn"
        on:click={() => {
          showSearchModal = true;
        }}>
        <svg viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M12.7646 13.4854L15.2793 16M7.5293 15C11.2572 15 14.2793 11.9779 14.2793 8.25C14.2793 4.52208 11.2572 1.5 7.5293 1.5C3.80137 1.5 0.779297 4.52208 0.779297 8.25C0.779297 11.9779 3.80137 15 7.5293 15Z"
            stroke="black"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round" />
        </svg>
      </button>
    {/if}
  </div>

  {#if showFloatingLikeOrComment && currentUser}
    <FloatingLikeOrComment group={group} mobile={mobile} />
  {/if}
</div>
